import { http } from '@/helpers/easyindustriaapi/config'

export default class SpecialtyController {
  constructor() {
    this.currentUser = JSON.parse(localStorage.getItem('user'))
    this.currentEmpresa = JSON.parse(localStorage.getItem('currentEmpresa'))
  }

  async getSpecialties(axiosParams) {
    try {
      const response = await http.get('/specialty', { params: axiosParams })
      return response.data
    } catch (error) {
      console.error('Erro ao buscar especialidades:', error)
      throw error
    }
  }
}